<app-topheader></app-topheader>
 
<div class="scrollingcontainer container">

<div *ngFor="let localloopdata of localloops; let b = index">
    <div *ngIf="b==0 && localloopdata.ltcName.includes('Local Loop')"><div class="locallooptemplate">LOCAL LOOP</div><div class="locallooptemplate">{{localloopdata.ltcName.split('Local')[0]}}</div></div>
    <div *ngIf="b==0 && localloopdata.ltcName.includes('Shuttle')"><div class="locallooptemplate">SHUTTLE</div><div class="locallooptemplate">{{localloopdata.ltcName.split('Shuttle')[0]}}</div></div>
    <div *ngIf="b==0 && localloopdata.ltcName.includes('Trolley')"><div class="locallooptemplate">TROLLEY</div><div class="locallooptemplate">{{localloopdata.ltcName.split('Trolley')[0]}}</div></div>
    <div *ngIf="b==0 && localloopdata.ltcName.includes('Graceland')"><div class="locallooptemplate">{{localloopdata.ltcName}}</div></div>
</div>

<div class="disclosuremessage">Please wear your lanyard. All times are approximate.</div>

<div class="excursiondirector" *ngFor="let crewbio of cruisebios; let c=index;">
    <div *ngIf="c>0 && cruisebios[c].crewRole!=cruisebios[c-1].crewRole && crewbio.crewRole!='' && 'Excursion Director'==crewbio.crewRole" class="excursiondirector">{{crewbio.crewRole}}:&nbsp;{{crewbio.crwName}}</div>        

    <div *ngIf="c>0 && cruisebios[c].crewRole!=cruisebios[c-1].crewRole && crewbio.crewRole!='' && crewbio.crlOBPortalPhoneDisp && 'Excursion Director'==crewbio.crewRole && crewbio.spcPhoneNumber!=null">
        <a href="tel:{{crewbio.spcPhoneNumber}}" class="excursiondirector">{{crewbio.spcPhoneNumber | phoneFormat}}</a>
    </div>
</div>


<div class="departuretimesfromship">Departure Times From Ship</div>

<!-- <div *ngFor="let localloopdata of localloops; let p = index">
    <div class="centerdeparturetimes">
        <div *ngFor="let stopTime of localloopdata.LocalLoopsStopTimeList; let x = index">
            <div *ngIf="p==0">
                <div class="row" *ngIf="(x%3)==0">
                    <div class="col-4 departuretimes" *ngFor="let stopTime of localloopdata.LocalLoopsStopTimeList.slice(x, x+3); let r = index;">
                        <span *ngIf="stopTime.StopTime != undefined"> {{ localloopdata.LocalLoopsStopTimeList[x + r].StopTime | date:'shortTime'}}</span>
                        <span *ngIf="(r%3)==0 || (r%3)==1" class="goldstar">&#9733;</span>
                        <span *ngIf="(r%3)==2" class="goldstar">&nbsp;</span>
                    </div>
                </div>     
            </div>
        </div>
    </div>
</div> -->

<div *ngFor="let localloopdata of localloopampm; let p = index;">
    <div *ngFor="let location of localloopdata.LocalLoopsLocationList;">
        <div *ngIf="p == 0">
            <div *ngFor="let something of localloopdata.futureTimes; let x = index;">     
                <div *ngIf="localloopdata.futureTimes.length!=0">
                    <div class="centerdeparturetimes">
                        <div class="row" *ngIf="(x%3)==0">
                            <div class="col-4 departuretimes" *ngFor="let something of localloopdata.futureTimes.slice(x, x+3); let r = index">
                                <span>{{localloopdata.futureTimes[x + r] | date:'shortTime'}}</span>
                                <span *ngIf="(r%3)==0 || (r%3)==1" class="goldstar">&#9733;</span>
                                <span *ngIf="(r%3)==2" class="goldstar">&nbsp;</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- if only am departure times -->
                <!-- <div *ngIf="localloopdata.morningTimes.length!=0 && localloopdata.afternoonTimes.length==0">
                    <div class="centerdeparturetimes">
                        <div class="row" *ngIf="(x%3)==0">
                            <div class="col-4 departuretimes" *ngFor="let something of localloopdata.maxLength.slice(x, x+3); let r = index">
                                <span>{{localloopdata.morningTimes[x + r] | date:'shortTime'}}</span>
                                <span *ngIf="(r%3)==0 || (r%3)==1" class="goldstar">&#9733;</span>
                                <span *ngIf="(r%3)==2" class="">&nbsp;</span>
                            </div>
                        </div>
                    </div>
                </div> -->
                <!-- if only pm departure times -->
                <!-- <div *ngIf="localloopdata.afternoonTimes.length!=0 && localloopdata.morningTimes.length==0">
                    <div class="centerdeparturetimes">
                        <div class="row" *ngIf="(x%3)==0">
                            <div class="col-4 departuretimes" *ngFor="let something of localloopdata.maxLength.slice(x, x+3); let r = index">
                                <span>{{localloopdata.afternoonTimes[x + r] | date:'shortTime'}}</span>
                                <span *ngIf="(r%3)==0 || (r%3)==1" class="goldstar">&#9733;</span>
                                <span *ngIf="(r%3)==2" class="goldstar">&nbsp;</span>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</div>



<div class="row">
    <div class="col-1"></div>
    <div class="col-10 goldbar d-flex justify-content-center">
        ______________________________________________________________________________
    </div>
</div>
    

<div *ngFor="let localloopdata of localloopampm; let y = index; let returnstop = last">
    <div *ngFor="let location of localloopdata.LocalLoopsLocationList; let lastlocationonastop = last">


    <div *ngIf="y==0" class="locallooplisttopmargin"></div>


        <div class="row">
            <span *ngIf="location.lllSortOrder == 1" class="col-3 localloopstopnumberwidth">
                <span *ngIf="y !== 0 && !returnstop" class="localloopstopnumber">{{localloopdata.StopGrouping}}</span>
            </span>
  
            <span *ngIf="location.lllSortOrder == 1" class="col-9">
                <span *ngIf="location.llladdress != null && location.lllDescription != 'Departure' && location.lllDescription != 'Return'">
                    <a href='http://maps.google.com/?q={{location.llladdress}}' target="_blank" class="locallooplocation">
                        {{location.lllName}}
                    </a>
                </span>
                <span *ngIf="location.llladdress == null && location.lllDescription != 'Departure' && location.lllDescription != 'Return'" class="locallooplocation">
                    {{location.lllName}}
                </span>
            </span>

            <span *ngIf="location.lllSortOrder > 1" class="col-12">
                <span *ngIf="location.llladdress != null && location.lllDescription != 'Departure' && location.lllDescription != 'Return'">
                    <a href='http://maps.google.com/?q={{location.llladdress}}' target="_blank" class="morethanonelocallooplocation">
                        {{location.lllName}}
                    </a>
                </span>
                <span *ngIf="location.llladdress == null && location.lllDescription != 'Departure' && location.lllDescription != 'Return'" class="morethanonelocallooplocation">
                    {{location.lllName}}
                </span>
            </span>     
        </div>  

        <div class="row">
            <div class="col-12">
                <div *ngIf="location.lllDescription != 'Departure' && location.lllDescription != 'Return'" class="locallooplocationdescription">{{location.lllDescription}}</div>
            </div>
        </div>

        <div class="dropoffpickuptimemargin">
            <div class="row">
                <div class="col-12 center">             
                    <div>
                        <span *ngIf="location.lllDescription != 'Departure' && location.lllDescription != 'Return' && lastlocationonastop" class="dropoffpickuptimelabel">
                        Drop Off/Pick Up Times:
                        </span> 
                    </div>         
                </div>
            </div>
        </div>

        <span *ngIf="y !== 0 && !returnstop && lastlocationonastop">
            <span *ngFor="let something of localloopdata.LocalLoopsStopTimeList; let j = index; let last = last;">
           
                <!-- regardless of am or pm or how many times there are, show all the times that haven't passed in 3 columns & make the last time red -->
                <div *ngIf="localloopdata.futureTimes.length!=0">
                    <div class="centerdropoffpickuptimes">
                        <div class="row" *ngIf="(j%3)==0">
                            <div class="col-4 dropoffpickuptimesamorpmonly" *ngFor="let something of localloopdata.LocalLoopsStopTimeList.slice(j, j+3); let a = index">
                                <span [ngClass]="{ 'finaldropoffpickuptime': last || j + a>=localloopdata.futureTimes.length-1}" class="dropoffpickuptimesamorpmonly"> {{localloopdata.futureTimes[j + a] | date:'shortTime'}}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- if both am & pm times show am as left column and pm as right column -->
                <!-- <span class="row dropoffpickuptimeslist" *ngIf="localloopdata.afternoonTimes.length!=0 && localloopdata.morningTimes.length!=0">
                    <div *ngIf="localloopdata.morningTimes.length!=0 && localloopdata.afternoonTimes.length!=0" class="col-6 dropoffpickuptimeswidth">
                        <span [ngClass]="{ 'finaldropoffpickuptime': last && localloopdata.afternoonTimes.length==0}" class="dropoffpickuptimesbothampm"> {{localloopdata.morningTimes[j] | date:'shortTime'}}</span>
                    </div>

                    <div *ngIf="localloopdata.afternoonTimes.length!=0 && localloopdata.morningTimes.length!=0" class="col-6 dropoffpickuptimeswidth">
                        <span *ngIf="localloopdata.afternoonTimes.length!=0">
                            <span [ngClass]="{ 'finaldropoffpickuptime': last || j>=localloopdata.afternoonTimes.length-1}" class="dropoffpickuptimesbothampm"> {{localloopdata.afternoonTimes[j] | date:'shortTime'}}</span>
                        </span>
                    </div>
                </span> -->


                <!-- if only am times show them as 3 columns, regardless of how many times there are -->
                <!-- <div *ngIf="localloopdata.morningTimes.length!=0 && localloopdata.afternoonTimes.length==0">
                    <div class="centerdropoffpickuptimes">
                        <div class="row" *ngIf="(j%3)==0">
                            <div class="col-4 dropoffpickuptimesamorpmonly" *ngFor="let something of localloopdata.maxLength.slice(j, j+3); let a = index">
                                <span [ngClass]="{ 'finaldropoffpickuptime': last || j + a>=localloopdata.morningTimes.length-1}" class="dropoffpickuptimesamorpmonly"> {{localloopdata.morningTimes[j + a] | date:'shortTime'}}</span>
                            </div>
                        </div>
                    </div>
                </div> -->

                <!-- if only pm times show them as 3 columns, regardless of how many times there are -->
                <!-- <div *ngIf="localloopdata.afternoonTimes.length!=0 && localloopdata.morningTimes.length==0">
                    <div class="centerdropoffpickuptimes">
                        <div class="row" *ngIf="(j%3)==0">
                            <div class="col-4 dropoffpickuptimesamorpmonly" *ngFor="let something of localloopdata.maxLength.slice(j, j+3); let a = index">
                                <span [ngClass]="{ 'finaldropoffpickuptime': last || j + a>=localloopdata.afternoonTimes.length-1}" class="dropoffpickuptimesamorpmonly"> {{localloopdata.afternoonTimes[j + a] | date:'shortTime'}}</span>
                            </div>
                        </div>
                    </div>
                </div> -->

                <!-- if only am times & there are 5 or more then show as 3 columns -->
                <!-- <div *ngIf="localloopdata.morningTimes.length>=5 && localloopdata.afternoonTimes.length==0">
                    <div class="centerdropoffpickuptimes">
                        <div class="row" *ngIf="(j%3)==0">
                            <div class="col-4 dropoffpickuptimesamorpmonly" *ngFor="let something of localloopdata.maxLength.slice(j, j+3); let e = index">
                                <span [ngClass]="{ 'finaldropoffpickuptime': last || j + e>=localloopdata.morningTimes.length-1}" class="dropoffpickuptimesamorpmonly"> {{localloopdata.morningTimes[j + e] | date:'shortTime'}}</span>
                            </div>
                        </div>
                    </div>
                </div> -->

                <!-- if only pm times & there are 5 or more then show in 3 columns -->
                <!-- <div *ngIf="localloopdata.afternoonTimes.length>=5 && localloopdata.morningTimes.length==0">
                    <div class="centerdropoffpickuptimes">
                        <div class="row" *ngIf="(j%3)==0">
                            <div class="col-4 dropoffpickuptimesamorpmonly" *ngFor="let something of localloopdata.maxLength.slice(j, j+3); let a = index">
                                <span [ngClass]="{ 'finaldropoffpickuptime': last || j + a>=localloopdata.afternoonTimes.length-1}" class="dropoffpickuptimesamorpmonly"> {{localloopdata.afternoonTimes[j + a] | date:'shortTime'}}</span>
                            </div>
                        </div>
                    </div>
                </div> -->

                <!-- if there are only am times & there are 4 or less then show in 1 column -->
                <!-- <div>
                    <span *ngIf="localloopdata.morningTimes.length<=4 && localloopdata.afternoonTimes.length==0 " class="center">
                        <span *ngIf="localloopdata.morningTimes[j]>=CurrentDateTime">
                            <span [ngClass]="{ 'finaldropoffpickuptime': last && localloopdata.afternoonTimes.length==0}" class="dropoffpickuptimes"> {{localloopdata.morningTimes[j] | date:'shortTime'}}</span>
                        </span>
                    </span>
                </div> -->

                <!-- if there are only pm times & there are 4 or less then show in 1 column -->
                <!-- <div>
                    <span *ngIf="localloopdata.afternoonTimes.length<=4 && localloopdata.morningTimes.length==0" class="center">
                        <span *ngIf="localloopdata.afternoonTimes.length!=0">
                            <span [ngClass]="{ 'finaldropoffpickuptime': last || j>=localloopdata.afternoonTimes.length-1}" class="dropoffpickuptimes"> {{localloopdata.afternoonTimes[j] | date:'shortTime'}}</span>
                        </span>
                    </span>
                </div> -->

                <!-- if it is the last time add a margin to the bottom -->
                <div *ngIf="last" class="endoflocalloopstopmargin"></div>

   

        
            </span>
        </span> 


    

    </div>
</div>



</div>


<app-bottommenu></app-bottommenu>
    